import { formatRFC3339 } from 'date-fns';

import { Component, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SnFormFieldConfig, ISnHasForm } from '@lib/form';
import { SnDrawerRef, SN_DRAWER_DATA } from '@lib/ui/drawer';

@Component({
  selector: 'sn-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements ISnHasForm {
  public readonly form = new UntypedFormGroup({});
  public formModel: any = {};

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router,
    private readonly _drawerRef: SnDrawerRef,
    @Inject(SN_DRAWER_DATA) public readonly formFields: SnFormFieldConfig[],
  ) {
    this.formModel = this._getFormQueryParams();
  }

  public submitForm(): void {
    const formData = { ...this.formModel };

    Object.keys(formData).forEach((key) => {
      if (formData[key] instanceof Date) {
        formData[key] = formatRFC3339(formData[key]);
      }
    });

    this._drawerRef.close(formData);
  }

  public resetForm(): void {
    this.form.reset();
    this.formModel = {};
    this._updateQueryParams();
    this._drawerRef.close();
  }

  public close(): void {
    this._drawerRef.close();
  }

  private _getFormQueryParams(): Object {
    const keys = this.formFields.map((field) => field.key.toString());
    const queryParams = {};
    keys.forEach((key: any) => {
      if (
        key === 'exclude_child_cameras' &&
        !this._activatedRoute.snapshot.queryParams['exclude_child_cameras']
      ) {
        queryParams['exclude_child_cameras'] = true;
      }
      if (this._activatedRoute.snapshot.queryParams[key]) {
        const value = this._activatedRoute.snapshot.queryParams[key];
        queryParams[key] = value === 'true' ? true : value === 'false' ? false : value;
      }
    });

    return queryParams;
  }

  private _updateQueryParams(): void {
    const formData = { ...this.formModel };

    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: formData,
    });
  }
}
